<div class="row mb-2">
    <div class="col-11">
        @if (cardTitle()) {
            <h6 [class]="classes()">{{ cardTitle()! | translate }}</h6>
        }
    </div>
    <div class="col-1 d-flex flex-row-reverse">
        @if (isEditable()) {
            <button type="button" class="btn btn-sm bg-card text-primary rounded-circle shadow-md" (click)="openAddModal()">
                <fa-icon [icon]="['fas', 'plus']"></fa-icon>
            </button>
        }
    </div>
</div>
@if (comments() && comments()!.length > 0) {
    @for (comment of comments(); track $index) {
        <adaa-note
            [number]="showNumber() ? $index + 1 : undefined"
            [title]="commentTitle(comment)"
            [subTitle]="commentDate(comment) | date: constants.dateTime"
            [message]="commentMessage(comment)"
            [isEditable]="isEditable()"
            (removeClicked)="commentRemoved.emit(comment)"
        />
    }
} @else if (comments() == null || comments()!.length === 0) {
    <div class="row">
        <div class="col-12">{{ noCommentsMessage() | translate }}</div>
    </div>
}
